import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Anchor, Divider, Stack, Text, Title } from "@mantine/core";

import { useTranslation } from "react-i18next";
import { SignUpForm } from "../../features/sign-up/SignUpForm";
import { SocialButtons } from "../../entities/components/SocialButtons";

interface Props {
  onSignUp: () => void;
  setMaxStep: (num: number) => void;
}

export const SignUpWiget: FC<Props> = ({ onSignUp, setMaxStep }) => {
  const { t } = useTranslation();
  const [isSocialLoading, setIsSocialLoading] = useState(false);

  return (
    <Stack align="stretch" justify="center" gap="24px">
      <Title size={36}>{t("sign_up")}</Title>
      <Text c="dimmed" size="md">
        {t("sign_up_social")}
      </Text>
      <SocialButtons
        setIsSocialLoading={setIsSocialLoading}
        setMaxStep={setMaxStep}
      />
      <Divider
        label={
          <Text c="dimmed" size="md">
            {t("or")}
          </Text>
        }
        labelPosition="center"
      />
      <Text c="dimmed" size="md">
        {t("sign_up_email")}
      </Text>
      <SignUpForm isSocialLoading={isSocialLoading} onSignUp={onSignUp} />
      <Text c="dimmed" size="md">
        {t("already_have_account")}{" "}
        <Anchor
          c="dimmed"
          to="/login/sign-in"
          underline="always"
          component={Link}
        >
          {t("sign_in")}
        </Anchor>
      </Text>
    </Stack>
  );
};
